import { Result, Button } from 'antd';
import React from 'react';

class notFound extends React.Component {
  
  componentDidMount(){
  let app=document.getElementsByClassName('App');
  console.log(app);
  app.background = 'none';
  }
  backHome=()=>{
    this.props.history.push('/index');
  }
  render() {

    return (
      <div className='NotFoundPage' style={{height: '100vh'}}>
      <Result style={{backgroundColor:'#f0f8ff',height:'100%'}}
        status="404"
        title="404"
        subTitle="对不起，这个页面未找到。"
        extra={<div><Button type="primary" onClick={this.backHome}>返回主页</Button></div>}
      />
      </div>
    );
  }
}
export default notFound;